<div #optionsContainer style="flex-direction: column;" fxFlex="grow">
    <mat-accordion>
        <div style='height: 600px; overflow-y: auto;' cdkDropList fxFlex="grow"
             [cdkDropListData]="sections"
             (cdkDropListDropped)="drop($event)">

            <div fxLayout="row" *ngFor="let section of sections" cdkDrag>
                <mat-expansion-panel (closed)="handleCloseSection(section)" (opened)="handleOpenSection(section)"
                                     [expanded]="section.expanded" fxFlex="100" expanded="true" class="mat-elevation-z3"
                                     style="margin-bottom: 10px; overflow-x: auto; ">

                    <mat-expansion-panel-header class="panel" style="align-items: center; justify-content: center;">

                        <mat-panel-title style="align-self: center;">
                            <div>Τμήμα {{section.id}} - {{section.value}}</div>
                        </mat-panel-title>

                        <button *ngIf="!section.displayed" mat-icon-button (click)="showSection($event, section)"
                                matTooltip="Προβολή τμήματος">
                            <mat-icon style="color: lightgray">visibility_off</mat-icon>
                        </button>
                        <button *ngIf="section.displayed" mat-icon-button (click)="showSection($event, section)"
                                matTooltip="Απόκρυψη τμήματος">
                            <mat-icon style="color: blue">visibility</mat-icon>
                        </button>
<!--                        <button mat-icon-button (click)="duplicateSection($event, section.id)"-->
<!--                                matTooltip="Αντιγραφή τμήματος">-->
<!--                            <mat-icon style="color: blue">content_copy</mat-icon>-->
<!--                        </button>-->
                        <button style="margin-right: 5px" mat-icon-button (click)="deleteSection($event, section.id)"
                                matTooltip="Αφαίρεση τμήματος">
                            <mat-icon style="color: red">delete</mat-icon>
                        </button>

                    </mat-expansion-panel-header>

                    <mat-divider></mat-divider>

                    <div fxLayout="column" style="margin-bottom: 25px;">

                        <!--Section Options-->
                        <div fxLayout="row wrap" fxLayoutAlign="space-between start" style="margin-top: 10px;">

                            <div fxLayout="column" fxFlex="48" class="section-options">
                                <span>{{section.label}}</span>
                                <mat-form-field>
                                    <label>
                                        <input autocomplete="off" matInput [(ngModel)]="section.value">
                                    </label>
                                </mat-form-field>
                            </div>
                            <div fxLayout="column" fxFlex="48" class="section-options">
                                <span>{{section.subLabel}}</span>
                                <mat-form-field>
                                    <label>
                                        <input autocomplete="off" matInput [(ngModel)]="section.subLabelValue">
                                    </label>
                                </mat-form-field>
                            </div>

<!--                            <div fxLayout="column" fxFlex="grow" class="section-options">-->
<!--                                <span>Στοίχιση:</span>-->
<!--                                <mat-form-field>-->
<!--                                    <mat-select [(ngModel)]="section.align">-->
<!--                                        <mat-option *ngFor="let align of alignmentOptions"-->
<!--                                                    [value]="align">{{align.label}}-->
<!--                                        </mat-option>-->
<!--                                    </mat-select>-->
<!--                                </mat-form-field>-->
<!--                            </div>-->
                            <!--                            <div fxLayout="column" fxFlex="48" class="section-options">-->
                            <!--                                <span>Απεικόνιση σε</span>-->
                            <!--                                <mat-form-field>-->
                            <!--                                    <mat-select [(ngModel)]="section.type">-->
                            <!--                                        <mat-option *ngFor="let type of sectionTypes"-->
                            <!--                                                    [value]="type">{{type.label}}</mat-option>-->
                            <!--                                    </mat-select>-->
                            <!--                                </mat-form-field>-->
                            <!--                            </div>-->
                            <!--                            <div fxLayout="column" fxFlex="48" class="section-options">-->
                            <!--                                <span>Στοίχιση</span>-->
                            <!--                                <mat-form-field>-->
                            <!--                                    <mat-select [(ngModel)]="section.align">-->
                            <!--                                        <mat-option *ngFor="let type of alignmentOptions"-->
                            <!--                                                    [value]="type">{{type.label}}</mat-option>-->
                            <!--                                    </mat-select>-->
                            <!--                                </mat-form-field>-->
                            <!--                            </div>-->

                        </div>
                        <!---->

                        <!--Member Options-->
                        <div fxLayout="row wrap" fxLayoutAlign="start center center" fxFlex="grow" fxLayoutGap="5px">

                            <div fxLayout="column" fxFlex="grow">
                                <div fxLayout="row" class="member-options-header" fxLayoutAlign="start center center"
                                     fxLayoutGap="5px">
                                    <div fxFlex="grow" style="font-family: 'Century Gothic', sans-serif; font-weight: 700;">
                                        Ενότητες
                                    </div>
                                    <div>
                                        <label (click)="addMember(section.id)">Νέα ενότητα</label>
                                    </div>
                                </div>

                                <div fxLayout="row" fxFlex="grow" *ngFor="let member of section.members">

                                    <mat-expansion-panel
                                      fxFlex="grow" expanded="true" class="mat-elevation-z3"
                                            style="margin-bottom: 10px; overflow-x: auto; ">
                                        <mat-expansion-panel-header class="panel"
                                                                    style="align-items: center; justify-content: center;">
                                            <mat-panel-title style="align-self: center;">
                                                <div>#{{member.id}}</div>
                                            </mat-panel-title>
                                            <button (click)="moveMemberUp($event, section, member.id)" mat-icon-button
                                                    matTooltip="Μετακίνηση προς τα πάνω"
                                                    [disabled]="isMemberFirst(section, member.id)">
                                                <mat-icon>arrow_upward</mat-icon>
                                            </button>
                                            <button (click)="moveMemberDown($event, section, member.id)" mat-icon-button
                                                    matTooltip="Μετακίνηση προς τα κάτω"
                                                    [disabled]="isMemberLast(section, member.id)">
                                                <mat-icon>arrow_downward</mat-icon>
                                            </button>
                                            <button mat-icon-button
                                                    (click)="removeMember($event, section.id, member.id)"
                                                    color="danger" matTooltip="Διαγραφή επιλογής">
                                                <mat-icon style="color: red;">delete</mat-icon>
                                            </button>
                                        </mat-expansion-panel-header>
                                        <mat-divider></mat-divider>

                                        <div fxLayout="row wrap" fxFlex="grow" fxLayoutAlign="space-between start">
                                            <div fxLayout="column" fxFlex="100" class="member-options">
                                                <span>Τίτλος:</span>
                                                <mat-form-field>
                                                    <label>
                                                        <input matInput [(ngModel)]="member.title"
                                                               placeholder="Τίτλος"/>
                                                    </label>
                                                </mat-form-field>
                                            </div>
                                            <div fxLayout="column" fxFlex="100" class="member-options">
                                                <div fxLayout="row" fxFlex="grow">
                                                    <span fxFlex="grow">Εξαγωγή απάντησης:</span>
                                                    <mat-slide-toggle color="primary" [(ngModel)]="member.isQuestion"></mat-slide-toggle>
                                                </div>

                                                <div fxLayout="row" fxFlex="grow">
                                                    <span fxFlex="grow">Υποχρεωτικό πεδίο:</span>
                                                    <mat-slide-toggle color="primary" [(ngModel)]="member.mandatory"></mat-slide-toggle>
                                                </div>

                                            </div>
                                            <div *ngIf="canSetTag(member.type)" fxLayout="column" fxFlex="100" class="member-options">
                                                <span>Tag:</span>
                                                <mat-form-field>
                                                    <mat-select [(ngModel)]="member.tag">
                                                        <mat-option *ngFor="let tag of defaultMemberTags"
                                                                    [value]="tag">{{tag.label}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div fxLayout="column" fxFlex="48" class="member-options">
                                                <span>Μέγεθος:</span>
                                                <mat-form-field>
                                                    <mat-select [(ngModel)]="member.proportion">
                                                        <mat-option *ngFor="let size of objectProportions"
                                                                    [value]="size">{{size.value}}%
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div fxLayout="column" fxFlex="48" class="member-options">
                                                <span>Στοίχιση:</span>
                                                <mat-form-field>
                                                    <mat-select [(ngModel)]="member.align">
                                                        <mat-option *ngFor="let align of alignmentOptions"
                                                                    [value]="align">{{align.label}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>


                                            <div fxLayout="column" fxFlex="grow" class="member-options">
                                                <span>Τύπος:</span>
                                                <div fxLayout="row" fxFlex="grow" fxLayoutGap="10px" fxLayoutAlign="start center center">
                                                    <mat-form-field [fxFlex]="memberHasActions(member) ? 95: 100">
                                                        <mat-select [(ngModel)]="member.type">
                                                            <mat-option *ngFor="let type of memberTypes"
                                                                        [value]="type">{{type.label}}</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                    <div
                                                         *ngIf="memberCanEdit(member)">
                                                        <mat-icon (click)="addOption(section.id, member.id)">edit</mat-icon>
                                                    </div>

                                                    <div
                                                            *ngIf="member.type.type === 'label'">
                                                        <mat-icon (click)="addLabelValue(member)">edit</mat-icon>
                                                    </div>

                                                    <!-- Type is Image-->
                                                    <div
                                                            *ngIf="member.type.type === 'image'">
                                                        <input #fileInput type="file"
                                                               (change)="onFileInput($event, section.id, member.id)"
                                                               id="img"
                                                               name="img" accept="image/*" style="display:none;">
                                                        <button mat-icon-button
                                                                (click)="fileInput.click()"
                                                                color="danger" matTooltip="Επιλογή εικόνας">
                                                            <mat-icon style="color: var(--secondaryBlue)">wallpaper
                                                            </mat-icon>
                                                        </button>
                                                    </div>
                                                    <!---->

                                                </div>
                                            </div>
                                        </div>
                                    </mat-expansion-panel>

                                </div>
                            </div>
                        </div>
                        <!--                        -->
                    </div>
                </mat-expansion-panel>

            </div>

        </div>

    </mat-accordion>
</div>
